import { render, staticRenderFns } from "./PromptAssignCategoryToProduct.vue?vue&type=template&id=9b351ffe&scoped=true&"
import script from "./PromptAssignCategoryToProduct.vue?vue&type=script&lang=js&"
export * from "./PromptAssignCategoryToProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b351ffe",
  null
  
)

export default component.exports